'use client'

import { useMemo } from 'react'

import Carousel from './Carousel'

export default function PricingSection() {
  const slides = useMemo(() => {
    const packages = [
      {
        name: 'Single Session',
        duration: '55 minutes',
        price: 150,
        description: 'Perfect for trying out the experience',
        isMostPopular: false,
      },
      {
        name: '10-Session Package',
        totalPrice: 1390,
        pricePerSession: 139,
        description: 'Ideal for building consistency and seeing real progress',
        isMostPopular: false,
      },
      {
        name: '20-Session Package',
        totalPrice: 2590,
        pricePerSession: 129.5,
        description: 'Best value for committed transformation',
        isMostPopular: false,
      },
      {
        name: '30-Session Package',
        totalPrice: 3590,
        pricePerSession: 119.67,
        description: 'Maximum savings for long-term success',
        isMostPopular: false,
      },
    ]

    return packages.map((pkg, index) => (
      <div
        key={index}
        className="relative rounded-[12px] border border-[#1a2d4d] bg-[#0a1628] p-[32px] shadow-lg transition-transform hover:scale-[1.02]"
      >
        <h3 className="mb-[8px] font-oswald text-[24px] font-bold text-FFFFFF uppercase">
          {pkg.name}
        </h3>

        {pkg.duration && (
          <p className="mb-[16px] text-[14px] text-[#D5D9DD]">{pkg.duration}</p>
        )}

        <p className="mb-[24px] text-[14px] text-[#D5D9DD]">
          {pkg.description}
        </p>

        <div className="mb-[24px]">
          <div className="flex items-baseline gap-[8px]">
            <span className="font-oswald text-[48px] font-bold text-FFFFFF">
              CHF {pkg.totalPrice || pkg.price}
            </span>
          </div>
          {pkg.pricePerSession && (
            <p className="mt-[4px] text-[14px] text-[#D5D9DD]">
              CHF {pkg.pricePerSession.toFixed(2)} per session
            </p>
          )}
        </div>

        <button className="w-full rounded-[8px] bg-linear-to-r from-[#88EFFF] to-[#27D3ED] py-[16px] text-[16px] font-semibold text-[#020e20] transition-opacity hover:opacity-90">
          Select Package
        </button>
      </div>
    ))
  }, [])

  return (
    <div
      id="pricing"
      className="relative bg-[url(/pricing.png)] bg-cover bg-center px-[20px] py-[80px] desktop:px-0 desktop:py-[80px]"
    >
      {/* Dark overlay */}
      <div className="bg-black/70 absolute inset-0" />
      <div className="relative z-10">
        <h2 className="mb-[48px] text-center font-oswald text-[12.3vw]/[1] font-bold text-FFFFFF uppercase desktop:px-[80px] desktop:text-[72px]">
          What I Offer
        </h2>

        <div className="mx-auto desktop:w-1/2 desktop:px-[60px]">
          <Carousel
            slidesPerView={{ mobile: 1, desktop: 2 }}
            gap={32}
            showDots={true}
            showArrows={false}
          >
            {slides}
          </Carousel>
        </div>
      </div>
    </div>
  )
}
